export type FlashMessageTypes = 'addressFailure' | 'addressSkipped' | 'success'

export enum FlashMessageVariants {
    error = 'error',
    success = 'success',
}

export type FlashMessageVariantTypes = keyof typeof FlashMessageVariants
